export default __webpack_public_path__ + "static/media/Logotip_mobile.2ed57223.svg";